import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Home() {
	const { user } = useAuth();
	
	return (
		<div className="text-center space-y-8">
		<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
		border border-farm-tan/30 dark:border-gray-700
		transition-colors duration-200">
		<h1 className="text-3xl font-bold text-farm-green dark:text-green-400
		mb-2">
		Welcome to Cedar Fork Farm
		</h1>
		<p className="text-farm-brown dark:text-amber-300 text-lg mb-6">
		Fresh pasture-raised eggs delivered with care from our family
		to yours.
		</p>
		
		<div className="grid gap-4">
		{user ? (
			<>
			<p className="text-farm-green dark:text-green-400 font-semibold
			text-lg">
			Welcome back, {user.firstName}! 🐔
			</p>
			<p className="text-gray-600 dark:text-gray-400">
			Account Balance:{" "}
			<span className="font-bold text-farm-green
			dark:text-green-400">
			{user.balance?.toFixed(2)} credits
			</span>
			</p>
			<Link
			to="/order"
			className="bg-farm-green text-white py-3 px-6 rounded-xl
			text-lg font-semibold hover:bg-green-700
			transition-colors"
			>
			Order Eggs
			</Link>
			</>
		) : (
			<>
			<Link
			to="/login"
			className="bg-farm-green text-white py-3 px-6 rounded-xl
			text-lg font-semibold hover:bg-green-700
			transition-colors"
			>
			Log In to Order
			</Link>
			<Link
			to="/register"
			className="border-2 border-farm-green text-farm-green
			dark:border-green-400 dark:text-green-400
			py-3 px-6 rounded-xl text-lg font-semibold
			hover:bg-farm-green hover:text-white
			dark:hover:bg-green-700 transition-colors"
			>
			Create an Account
			</Link>
			</>
		)}
		</div>
		</div>
		
		<div className="grid grid-cols-3 gap-4 text-center">
		{[
			{ emoji: "🥚", title: "Farm Fresh", desc: "Collected daily" },
			{ emoji: "🌿", title: "Pasture Raised", desc: "Free range hens" },
			{ emoji: "❤️", title: "Family Owned", desc: "Since day one" },
		].map(({ emoji, title, desc }) => (
			<div
			key={title}
			className="bg-white dark:bg-gray-800 rounded-xl p-4 shadow
			border border-farm-tan/20 dark:border-gray-700
			transition-colors duration-200"
			>
			<div className="text-3xl mb-1">{emoji}</div>
			<div className="font-bold text-farm-green dark:text-green-400
			text-sm">
			{title}
			</div>
			<div className="text-gray-500 dark:text-gray-400 text-xs">
			{desc}
			</div>
			</div>
		))}
		</div>
		</div>
	);
}
